import { render, staticRenderFns } from "./NotificationOrderDetails.vue?vue&type=template&id=42505b7e&scoped=true&"
import script from "./NotificationOrderDetails.vue?vue&type=script&lang=js&"
export * from "./NotificationOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./NotificationOrderDetails.vue?vue&type=style&index=0&id=42505b7e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42505b7e",
  null
  
)

export default component.exports